"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form1040GrossAnnualIncomeStrategy = exports.IrsFormVerificationStatus = exports.PaystubProvider = exports.ManualIncomeVerificationResult = exports.IncomeVerificationPurpose = exports.IncomeVerificationResultType = exports.UnsuccessfulPlaidOwnerNameMatchStatus = exports.IncomeVerificationDocumentAdditionalInfoKey = exports.ManualIncomeVerificationSource = exports.IncomeVerificationMethod = exports.MANUAL_VERIFICATION_DOCUMENT_TYPES = exports.IncomeVerificationDocumentType = void 0;
/** @TranslateToPython @TranslateToEnum */
var IncomeVerificationDocumentType;
(function (IncomeVerificationDocumentType) {
    IncomeVerificationDocumentType["PAY_STUBS"] = "PAY_STUBS";
    IncomeVerificationDocumentType["W2"] = "W2";
    IncomeVerificationDocumentType["TAX_RETURN"] = "TAX_RETURN";
    IncomeVerificationDocumentType["STATE_TAX_RETURN"] = "STATE_TAX_RETURN";
    IncomeVerificationDocumentType["BANK_STATEMENT"] = "BANK_STATEMENT";
    IncomeVerificationDocumentType["FORM_1099"] = "FORM_1099";
    IncomeVerificationDocumentType["PROFIT_AND_LOSS"] = "PROFIT_AND_LOSS";
    IncomeVerificationDocumentType["SOCIAL_SECURITY"] = "SOCIAL_SECURITY";
    IncomeVerificationDocumentType["PENSION"] = "PENSION";
    IncomeVerificationDocumentType["RETIREMENT"] = "RETIREMENT";
    // Non uploaded docs
    IncomeVerificationDocumentType["PLAID"] = "PLAID";
    IncomeVerificationDocumentType["WORK_NUMBER"] = "WORK_NUMBER";
    IncomeVerificationDocumentType["EXPERIAN"] = "EXPERIAN";
    //  Special value
    IncomeVerificationDocumentType["STATED_INCOME"] = "STATED_INCOME";
    IncomeVerificationDocumentType["IGNORED_DOC"] = "IGNORED_DOC";
})(IncomeVerificationDocumentType || (exports.IncomeVerificationDocumentType = IncomeVerificationDocumentType = {}));
/** @TranslateToPython */
exports.MANUAL_VERIFICATION_DOCUMENT_TYPES = [
    IncomeVerificationDocumentType.PAY_STUBS,
    IncomeVerificationDocumentType.W2,
    IncomeVerificationDocumentType.TAX_RETURN,
    IncomeVerificationDocumentType.BANK_STATEMENT,
    IncomeVerificationDocumentType.FORM_1099,
    IncomeVerificationDocumentType.PROFIT_AND_LOSS,
    IncomeVerificationDocumentType.SOCIAL_SECURITY,
    IncomeVerificationDocumentType.PENSION,
    IncomeVerificationDocumentType.RETIREMENT,
    IncomeVerificationDocumentType.STATE_TAX_RETURN,
];
/** @TranslateToPython **/
var IncomeVerificationMethod;
(function (IncomeVerificationMethod) {
    IncomeVerificationMethod["experian"] = "experian";
    IncomeVerificationMethod["workNumber"] = "workNumber";
    IncomeVerificationMethod["truework"] = "truework";
    IncomeVerificationMethod["plaid"] = "plaid";
    IncomeVerificationMethod["manualVerification"] = "manualVerification";
    IncomeVerificationMethod["irs"] = "irs";
    IncomeVerificationMethod["all"] = "all";
    IncomeVerificationMethod["unknown"] = "unknown";
    IncomeVerificationMethod["statedIncome"] = "statedIncome";
})(IncomeVerificationMethod || (exports.IncomeVerificationMethod = IncomeVerificationMethod = {}));
/** @TranslateToPython @TranslateToEnum */
var ManualIncomeVerificationSource;
(function (ManualIncomeVerificationSource) {
    ManualIncomeVerificationSource["MANUAL"] = "MANUAL";
    ManualIncomeVerificationSource["OCROLUS"] = "OCROLUS";
    ManualIncomeVerificationSource["GOOGLE"] = "GOOGLE";
    ManualIncomeVerificationSource["GEMINI"] = "GEMINI";
})(ManualIncomeVerificationSource || (exports.ManualIncomeVerificationSource = ManualIncomeVerificationSource = {}));
/** @TranslateToPython @TranslateToEnum */
var IncomeVerificationDocumentAdditionalInfoKey;
(function (IncomeVerificationDocumentAdditionalInfoKey) {
    IncomeVerificationDocumentAdditionalInfoKey["payPeriodEndDate"] = "payPeriodEndDate";
    IncomeVerificationDocumentAdditionalInfoKey["plaidReportGenerationDate"] = "plaidReportGenerationDate";
    IncomeVerificationDocumentAdditionalInfoKey["missingFields"] = "missingFields";
})(IncomeVerificationDocumentAdditionalInfoKey || (exports.IncomeVerificationDocumentAdditionalInfoKey = IncomeVerificationDocumentAdditionalInfoKey = {}));
var UnsuccessfulPlaidOwnerNameMatchStatus;
(function (UnsuccessfulPlaidOwnerNameMatchStatus) {
    UnsuccessfulPlaidOwnerNameMatchStatus["noNamesFound"] = "noNamesFound";
    UnsuccessfulPlaidOwnerNameMatchStatus["nameMismatch"] = "nameMismatch";
})(UnsuccessfulPlaidOwnerNameMatchStatus || (exports.UnsuccessfulPlaidOwnerNameMatchStatus = UnsuccessfulPlaidOwnerNameMatchStatus = {}));
var IncomeVerificationResultType;
(function (IncomeVerificationResultType) {
    IncomeVerificationResultType["incomeVerified"] = "incomeVerified";
    IncomeVerificationResultType["incomeNotVerified"] = "incomeNotVerified";
    IncomeVerificationResultType["bankAccountWasFraud"] = "bankAccountWasFraud";
    IncomeVerificationResultType["plaidDoesNotMatchApplicantNames"] = "plaidDoesNotMatchApplicantNames";
    IncomeVerificationResultType["plaidBankIsOnDenyList"] = "plaidBankIsOnDenyList";
    IncomeVerificationResultType["loanApplicationStatusDuplicate"] = "loanApplicationStatusDuplicate";
    IncomeVerificationResultType["loanApplicationStatusWithdrawn"] = "loanApplicationWithdrawn";
    IncomeVerificationResultType["cannotInitiateIncomeVerification"] = "cannotInitiateIncomeVerification";
})(IncomeVerificationResultType || (exports.IncomeVerificationResultType = IncomeVerificationResultType = {}));
// keep in line with aven_frontend/aven/src/services/api.ts
var IncomeVerificationPurpose;
(function (IncomeVerificationPurpose) {
    IncomeVerificationPurpose["automatic"] = "automatic";
    IncomeVerificationPurpose["plaid"] = "plaid";
    IncomeVerificationPurpose["irs"] = "irs";
    IncomeVerificationPurpose["manual"] = "manual";
    /** @deprecated Ocrolus no longer triggers income verification; kept so historical events stay readable */
    IncomeVerificationPurpose["_ocrolus"] = "ocrolus";
    IncomeVerificationPurpose["gemini"] = "gemini";
    IncomeVerificationPurpose["_deprecatedDaemon"] = "daemon";
    IncomeVerificationPurpose["staleProgress"] = "staleProgress";
})(IncomeVerificationPurpose || (exports.IncomeVerificationPurpose = IncomeVerificationPurpose = {}));
// delineates all possible outcomes from manual income verification.
var ManualIncomeVerificationResult;
(function (ManualIncomeVerificationResult) {
    ManualIncomeVerificationResult["succeed"] = "succeed";
    ManualIncomeVerificationResult["documentAuthenticityInsufficient"] = "documentAuthenticityInsufficient";
    ManualIncomeVerificationResult["identityInformationInsufficient"] = "identityInformationInsufficient";
    ManualIncomeVerificationResult["doubleEntryIssue"] = "doubleEntryIssue";
    ManualIncomeVerificationResult["fatFingersIssue"] = "fatFingersIssue";
    ManualIncomeVerificationResult["incomeInsufficientForQualOffer"] = "incomeInsufficientForQualOffer";
    ManualIncomeVerificationResult["incomeSufficientForDifferentQualOffer"] = "incomeSufficientForDifferentQualOffer";
    ManualIncomeVerificationResult["incomeSufficientForSameQualOffer"] = "incomeSufficientForSameQualOffer";
    ManualIncomeVerificationResult["humanInvestigate"] = "humanInvestigate";
    ManualIncomeVerificationResult["involuntaryLienVerification"] = "involuntaryLienVerification";
    ManualIncomeVerificationResult["activeForeclosureVerification"] = "activeForeclosureVerification";
    ManualIncomeVerificationResult["ofacVerification"] = "ofacVerification";
})(ManualIncomeVerificationResult || (exports.ManualIncomeVerificationResult = ManualIncomeVerificationResult = {}));
var PaystubProvider;
(function (PaystubProvider) {
    PaystubProvider["ADP"] = "ADP";
    PaystubProvider["Gusto"] = "Gusto";
    PaystubProvider["Paychex"] = "Paychex";
    PaystubProvider["Paycor"] = "Paycor";
    PaystubProvider["Quickbooks"] = "Quickbooks";
})(PaystubProvider || (exports.PaystubProvider = PaystubProvider = {}));
var IrsFormVerificationStatus;
(function (IrsFormVerificationStatus) {
    IrsFormVerificationStatus["notEligible"] = "notEligible";
    IrsFormVerificationStatus["canStart"] = "canStart";
    IrsFormVerificationStatus["completed"] = "completed";
})(IrsFormVerificationStatus || (exports.IrsFormVerificationStatus = IrsFormVerificationStatus = {}));
/** @TranslateToPython @TranslateToEnum */
var Form1040GrossAnnualIncomeStrategy;
(function (Form1040GrossAnnualIncomeStrategy) {
    /* max(incomeFromWork, totalIncome) */
    Form1040GrossAnnualIncomeStrategy["ALGO_BEFORE_2025_04_29"] = "ALGO_BEFORE_2025_04_29";
    /* max(w2TotalIncome or 0, totalIncome or 0) + (retiredIncome or 0) */
    Form1040GrossAnnualIncomeStrategy["ALGO_FROM_2025_04_29"] = "ALGO_FROM_2025_04_29";
    /* max(incomeFromWork or 0, totalIncome or 0) + 2a + 3a + max(4a, 4b) - 4b + max(5a, 5b) - 5b + max(6a, 6b) - 6b
    1P: https://docs.google.com/document/d/1jl0HT_ZbIlX_CtxWxKoXbEik0XuZoEAIVTlh4NMFMFs/edit?tab=t.0 */
    Form1040GrossAnnualIncomeStrategy["ALGO_FROM_2026_03_30"] = "ALGO_FROM_2026_03_30";
})(Form1040GrossAnnualIncomeStrategy || (exports.Form1040GrossAnnualIncomeStrategy = Form1040GrossAnnualIncomeStrategy = {}));
